import NavComponent from "../lib/nav_component";

export const NavBarComponentConfig = {
    baseHtmlClass: 'nav_bar',
    selector: '.nav_bar',

    bodyContentScrolledModifier: 'scrolled',
}

export class NavBarComponent extends NavComponent {

    constructor(id_or_element, primaryPaneComponent) {
        super(id_or_element, NavBarComponentConfig);
        this.primaryPaneComponent = primaryPaneComponent;
        this.hasBodyContentScrolled = false;

    }

    setBodyContentScrolled(value) {
        // For performance, only set and render when the value actually changes.
        if (this.hasBodyContentScrolled !== value) {
            this.hasBodyContentScrolled = value;
            this.render();
        }
    }

    render() {
        this.conditionallySetHtmlClassState(this.hasBodyContentScrolled, NavBarComponentConfig.bodyContentScrolledModifier);
    }

}